var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"banner-bg",style:(_vm.bgStyle)}),_c('div',{staticClass:"banner-mask"}),_c('div',{staticClass:"banner-title"},[_c('p',{staticClass:"title-main"},[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('p',{staticClass:"title-sub"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }